
export const estats = [
  { nom: "Impresión",   icon: "mdi-printer-outline" },
  { nom: "Transporte",  icon: "mdi-truck-outline" },
  { nom: "Por empezar", icon: "mdi-package-variant-closed-check" },
  { nom: "En curso",    icon: "mdi-mailbox-outline" },
  { nom: "Finalizada",  icon: "mdi-check-circle-outline" },
]

export const estatActual = 1

/**
 * Calcula l'estat actual d'una campanya en funció dels serveis ja iniciats
 * Accepta tant un array d'agrupacions [{ desc_agrupada, serveis: [...] }]
 * com directament un array de serveis [{ service_type, start_date, end_date }]
 *
 * @param {Object} campanya - La campanya actual (ha de tenir state i desc_agrupada)
 * @param {Array} agrupacionsOserveis - Agrupacions o bé serveis directes
 * @returns {Object} { estatActual: number, saltarPrimers: boolean }
 */
export function calcularEstatActual(campanya, agrupacionsOserveis) {

  //console.log (campanya.state)
  //console.log (agrupacionsOserveis)
  const avui = new Date().toISOString().split('T')[0]

  // Map servei → índex
  const mapServiceToIndex = {
    21: 0, // Impresión
    94: 0, // Impresión
    8:  1, // Transporte
    1:  2, // Repartiendo
    5:  2, // Repartiendo
    6:  2,  // Repartiendo
    106:  2,  // Repartiendo BM-NRX
    107:  2,  // Repartiendo BI-NRX
    108:  2  // Repartiendo ET-RX
  }

  let serveis = []
  // 👉 Cas 1: agrupacions amb serveis
  if (
    Array.isArray(agrupacionsOserveis) &&
    agrupacionsOserveis.length > 0 &&
    agrupacionsOserveis[0].serveis
  ) {
    const agrupacio = agrupacionsOserveis.find(
      a => a.desc_agrupada === campanya.desc_agrupada
    )
    serveis = agrupacio ? agrupacio.serveis : []
  } else {
    // 👉 Cas 2: array directe
    serveis = agrupacionsOserveis
  }

  // 🔁 Cas especial: campanya finalitzada
  if (campanya.state === 'done' || campanya.state === 'Finalizada') {
     return {
      estatActual: 4,
      saltarPrimers:  !serveis.some(servei =>[8, 21, 94].includes(Number(servei.service_type)) ) //Revisar que el servei sigui diferent a Impresió o transport
    }
  }

  // Si no trobem serveis → per defecte Repartiendo
  if (!serveis || serveis.length === 0) {
    return {
      estatActual: 2,
      saltarPrimers: true
    }
  }

  // Comprovem si algun servei és conegut (està al mapa)
  const teServeiConegut = serveis.some(s => s.service_type in mapServiceToIndex)

  // Si no hi ha cap servei conegut → saltarPrimers = true
  var saltarPrimers = !teServeiConegut
 
  //Revisar que el servei sigui diferent a Impresió o transport
  saltarPrimers = !serveis.some(servei =>[8, 21, 94].includes(Number(servei.service_type)) )
  

  // Calcular estat segons els serveis coneguts i data
  let maxIndex = -1
  serveis.forEach(serv => {
    if (
      serv.start_date <= avui &&
      mapServiceToIndex[serv.service_type] !== undefined
    ) {
      maxIndex = Math.max(maxIndex, mapServiceToIndex[serv.service_type])
    }
  })

  const campanyaFinalitzadaPerDates =
    (campanya && campanya.end_date && campanya.end_date < avui) ||
    (serveis.length > 0 && serveis.every(serv => serv.end_date && serv.end_date < avui))

  if (campanyaFinalitzadaPerDates) {
    return {
      estatActual: 4,
      saltarPrimers
    }
  }

  return {
    estatActual: maxIndex >= 0 ? maxIndex : 2,
    saltarPrimers
  }
}


/**
 *  Carrega els serveis des del localStorage
 * @param {*} idCamp 
 * @returns 
 */
export function loadServeis(idCamp) {
  try {
    const raw = localStorage.getItem(`campanya_${idCamp}_serveis`)
    return raw ? JSON.parse(raw) : []
  } catch {
    return []
  }
}

/**
 * Comprova si en els serveis guardats al localStorage hi ha algun service_type = 5
 * @param {number|string} idCamp - identificador de la campanya
 * @returns {boolean} true si existeix almenys un servei amb service_type=5
 */
export function existeixEntregaTienda(idCamp) {
  try {
    const raw = localStorage.getItem(`campanya_${idCamp}_serveis`)
    if (!raw) return null

    const serveis = JSON.parse(raw)

    if (!Array.isArray(serveis)) return null

    // Busca el primer servei amb service_type = 5 o 108
    const servei = serveis.find(s => [5, 108].includes(Number(s.service_type)))

    // Si existeix, retorna el seu idCamp
    return servei ? servei.idCamp : null
  } catch {
    return null
  }
}

